import { render, staticRenderFns } from "./ShippingMethodsListLoader.vue?vue&type=template&id=69aa70fc&"
import script from "./ShippingMethodsListLoader.vue?vue&type=script&lang=js&"
export * from "./ShippingMethodsListLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports